import { Observable } from 'rxjs';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoValidarPersonalizacoesRequest } from '@shared/services/requests/formula/formula-catalogo-validar-personalizacoes.request';
import { FormulaCatalogoValidacaoResponse } from '@shared/services/responses/formula/formula-catalogo-validacao.response';

export class FormulaEditorDialogData {
    titulo: string;
    formulas: FormulaCatalogoItemStruct[];
    estadosIniciais: FormulaItemStruct[];
    estadosFormulasAgregados?: FormulaItemStruct[];
    contextoRaiz: string;
    validarPersonalizacoes: (
        request: FormulaCatalogoValidarPersonalizacoesRequest,
    ) => Observable<FormulaCatalogoValidacaoResponse>;
    mostrarVigencia?: boolean;
    mostrarBadgeModelo?: boolean;
    mensagemAlerta?: string;
    /**
     * Referência circular é aceita com aviso e configurada no salvar da entidade (padrão true).
     * Custo/venda passa false: lá o ciclo é inválido e a personalização é recusada.
     */
    permitirConfigurarCiclo?: boolean;
}
